import React from 'react'
// import thunk from 'redux-thunk'
import ReactDOM from 'react-dom'
// import { Provider } from 'react-redux'
import { BrowserRouter as Router, Route } from 'react-router-dom'
// import { createStore, applyMiddleware } from 'redux'
// import logger from 'redux-logger'

// import combinedReducers from './redux/reducers'
// import Root from 'components/root/Root'
import {default as App} from 'containers/app/AppContainer'
import googleAnalyticsTracker from 'components/googleAnalyticsTracker/googleAnalyticsTracker'

import 'styles/helpers.css'
import 'styles/styles.css'

// let store = createStore(combinedReducers,
//   applyMiddleware(thunk, logger)
// )

ReactDOM.render(
  // <Provider store={store}>
    <Router>
      <Route component={googleAnalyticsTracker(App)}/>
    </Router>,
  // </Provider>,
  document.getElementById('root')
)



// WEBPACK FOOTER //
// ./src/index.js